export default "../css/5e5c521dddeb44fad8a9c783a4efac84.ttf";